module.exports = __webpack_public_path__ + "img/59ne.887947ad.svg";